document.addEventListener('DOMContentLoaded', () => {
    const subMenu = document.querySelector('.details-lvl-1 > .dropdown .dropdown__container .dropdown__nav');
    const firstSubMenu = subMenu.querySelector('li:first-child');

    subMenu.querySelectorAll('li').forEach((li) => {
        const details = li.querySelector('details');

        li.addEventListener('mouseover', () => {
            li.classList.add('hovered');
            if (details) {
                details.open = true;
            }
        });

        li.addEventListener('mouseleave', () => {
            li.classList.remove('hovered');
            if (details) {
                details.open = false;
            }
        });
    });

    document.querySelector('.menu-item-mega-menu')
        .addEventListener('mouseover', () => {
            const hasHovered = subMenu.querySelector('li.hovered');
            if (!hasHovered) {
                firstSubMenu.classList.add('hovered');
                const firstDetails = firstSubMenu.querySelector('details');
                if (firstDetails) {
                    firstDetails.open = true;
                }
            }
        });
});
